<div class="container">
  <div class="benefits">
    <div class="benefits__txt">
      <p [innerHTML]="data.vantages_list_title"></p>
    </div>
    <div class="benefits__nav">
      <button
        type="button"
        class="benefits__arrow benefits__arrow--prev"
        (click)="scrollPrev()"
        aria-label="Anterior"
      ></button>
      <div class="carousel" #scrollContainer carousel>
        <div class="slide" *ngFor="let item of data.vantages_list">
          <div class="slide__card">
            <div class="slide__card__img" *ngIf="item.image">
              <img [src]="item.image.url" alt="" />
            </div>
            <div class="slide__card__title">
              <div [innerHTML]="item.title"></div>
            </div>
            <div class="slide__card__line"></div>
            <div class="slide__card__text">
              <p [innerHTML]="item.text"></p>
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="benefits__arrow benefits__arrow--next"
        (click)="scrollNext()"
        aria-label="Próximo"
      ></button>
    </div>
  </div>
</div>
